import moment from "moment";

export default class SubscriptionStatus {
  constructor({status, trial_end, has_payment_method}) {
    this._status = status;
    this._hasPaymentMethod = has_payment_method;

    if (trial_end) {
      this.trialExpiration = moment.unix(trial_end).startOf("day");
    }
  }

  get active() {
    return (
      "active" === this._status ||
      ("trialing" === this._status && (this._hasPaymentMethod || this.trialDaysRemaining >= 0))
    );
  }

  get trialWarning() {
    return (
      !this._hasPaymentMethod &&
      this._status === "trialing" &&
      this.trialDaysRemaining < 15 &&
      this.trialDaysRemaining >= 0
    );
  }

  get trialDaysRemaining() {
    return this.trialExpiration ? this.trialExpiration.diff(moment().startOf("day"), "days") : null;
  }
}



// WEBPACK FOOTER //
// ./src/components/SubscriptionStatus/index.js